import { render, staticRenderFns } from "./AfricanValueChain.vue?vue&type=template&id=c49c6c0c&scoped=true&"
import script from "./AfricanValueChain.vue?vue&type=script&lang=js&"
export * from "./AfricanValueChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49c6c0c",
  null
  
)

export default component.exports